import ACL from './ACL';

export const acl = new ACL();

export default {
    install(app) {
        return app.provide('$acl', acl);
    },
};
